/* ─────────────────────────────────────────────────────────────
   CART UPSELL — Barbed Visions
   File: assets/cart-upsell.js
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (window.__BV_CART_UPSELL__) return;

  function routeFor(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function sectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function swapDrawerSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var inner = document.querySelector('cart-drawer .drawer__inner');
      var fresh = sectionInnerHTML(sections['cart-drawer'], '.drawer__inner');
      if (inner && fresh !== null) inner.innerHTML = fresh;
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var freshBubble = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && freshBubble !== null) bubble.innerHTML = freshBubble;
    }
  }

  function addToCart(variantId, btn) {
    var product = btn.closest('[data-bv-upsell-product]');
    var allSizes = product ? product.querySelectorAll('.bv-upsell__size') : [];
    allSizes.forEach(function (b) {
      b.disabled = true;
      b.classList.add('is-adding');
    });

    window.fetch(routeFor('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (resp) {
        if (resp.sections) {
          swapDrawerSections(resp.sections);
        }
        allSizes.forEach(function (b) {
          b.disabled = false;
          b.classList.remove('is-adding', 'is-selected');
        });
        btn.classList.add('is-added');
        btn.textContent = '✓ ' + btn.textContent.replace('✓ ', '');

        var hint = product ? product.querySelector('.bv-upsell__size-hint') : null;
        if (hint) {
          hint.textContent = '✓ Added to cart';
          hint.classList.remove('is-hidden');
        }
      })
      .catch(function () {
        allSizes.forEach(function (b) {
          b.disabled = false;
          b.classList.remove('is-adding');
        });
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-bv-upsell-size]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var variantId = parseInt(btn.dataset.bvUpsellSize, 10);
    if (!variantId) return;

    var product = btn.closest('[data-bv-upsell-product]');
    if (product) {
      product.querySelectorAll('.bv-upsell__size').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');

      var hint = product.querySelector('.bv-upsell__size-hint');
      if (hint) hint.classList.add('is-hidden');
    }

    addToCart(variantId, btn);
  });

  window.__BV_CART_UPSELL__ = { version: '2.0.0' };
})();